import type { Config } from 'tailwindcss';

export const screens = {
  sm: 408,
  md: 600,
  lg: 896,
  xl: 1024,
  xxl: 1176,
};

const config: Config = {
  important: true,
  content: [
    './pages/**/*.{js,ts,jsx,tsx,mdx}',
    './components/**/*.{js,ts,jsx,tsx,mdx}',
    './app/**/*.{js,ts,jsx,tsx,mdx}',
  ],

  theme: {
    screens: {
      sm: `${screens.sm}px`,
      md: `${screens.md}px`,
      lg: `${screens.lg}px`,
      xl: `${screens.xl}px`,
      xxl: `${screens.xxl}px`,
    },
    fontSize: {
      xxs: ['10px', '14px'],
      xs: ['12px', '16px'],
      sm: ['14px', '24px'],
      base: ['16px', '24px'],
      medium: ['18px', '24px'],
      lg: ['20px', '28px'],
      xl: ['24px', '32px'],
      xxl: ['32px', '48px'],
      big: ['36px', '48px'],
    },
    extend: {
      colors: {
        // Green
        success: {
          light: '#edfaed',
          midLight: 'rgba(41,155,41,.25)',
          mid: '#299B29',
        },

        donationsTabButton: {
          default: {
            bg: '#F4F4F4',
            text: '#0D0D0C',
          },
          hover: {
            bg: '#FCF2EC',
            text: '#0D0D0C',
          },
          pressed: {
            bg: '#FADCCC',
            text: '#E66D45',
          },
          active: {
            bg: '#FCF2EC',
            text: '#CF623E',
          },
        },

        // Red
        warning: '#DF4343',

        alert: '#FFF77C',

        // Orange
        primary: {
          light: '#FADCCC',
          mid: '#E66D45',
          dark: '#AE3D17',
        },

        // Yellow
        secondary: {
          light: '#FFF8EE',
          mid: '#E3C7A2',
        },

        // Gray
        neutral: {
          white: '#fff',
          light: '#ebebeb',
          midLight: '#d7d7d7',
          smallDescription: '#808080',
          mid: '#727271',
          dark: '#141412',
          semiTransparent: 'rgba(20,20,18,.6)',
          profileMenuIconsColor: '#b3b3b4',
          blackTooltipBackground: 'rgba(0,0,0,0.8)',
        },

        social: {
          facebook: {
            light: '#2c64f6',
            dark: '#0a47e5',
          },
          x: {
            light: '#42423d',
            dark: '#0d0d0c',
          },
          whatsapp: {
            light: '#50c746',
            dark: '#3ca733',
          },
        },
      },
      boxShadow: {
        secondaryGlow: '0px 0px 25px 20px #FFF8EE',
        white: '0 2px 8px 16px white',
      },
      backgroundImage: {
        instagramGradient: 'linear-gradient(90deg, #FF7A00 0%, #FF0169 51.5%, #D300C5 91.07%)',
        instagramTemplateImageGradient: `linear-gradient(180deg, #fadccc 0%, rgba(250, 220, 204, 0) 74.5%), url('/public/images/ig-story-background.svg')`,
      },
    },
  },
  plugins: [],
};
export default config;
